/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
let app = {};
(function ($) {
    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    let Sage = {
        // All pages
        'common': {
            init() {

              // Navigation Stuff
              const $nav = $('#nav');
              const $navToggle = $('#nav_toggle');
              const $subMenuItems = $('#nav .menu-item-has-children');
              const $headerWrapper = $('.header_wrapper');

              const navSuperClass = 'super';
              const navSubModeClass = 'view-sub-menu';
              const navBackClass = 'back';

              $nav.click(function(event) {
                const target = event.target.tagName;
                if (target === 'NAV' || target === 'UL') {
                  $subMenuItems.removeClass(navSuperClass);
                  $nav.removeClass(navSubModeClass);
                  $navToggle.removeClass(navBackClass);
                }
              });

              $navToggle.click(function(event) {
                event.preventDefault();

                if ($navToggle.hasClass(navBackClass)) {
                  $subMenuItems.removeClass(navSuperClass);
                  $nav.removeClass(navSubModeClass);
                  $navToggle.removeClass(navBackClass);
                } else {
                  $headerWrapper.toggleClass('visible');
                }
              });

              $subMenuItems.click(function(event) {
                console.log(event);
                if (event.target.tagName === 'LI') {
                  const $self = $(this);
                  const isSuper = $self.hasClass(navSuperClass);

                  $subMenuItems.removeClass(navSuperClass);
                  if (!isSuper) {
                    $nav.addClass(navSubModeClass);
                    $navToggle.addClass(navBackClass);
                    $self.addClass(navSuperClass);
                  } else {
                    $nav.removeClass(navSubModeClass);
                    $navToggle.removeClass(navBackClass);
                  }
                }
              });
            },
            finalize() {
                // JavaScript to be fired on all pages, after page specific JS is fired
            }
        }, // Home page
        'home': {
          init() {
            const $content = $('#content');
            const $overlay = $('#overlay');
            const $video_cta_link = $('#video_cta');
            const $video_player = $('#video_player');
            const $video_player_close = $video_player.find('.close');
            const $video_bg = $('#bg_video-right video');

            app.parent_el = document.getElementById('app_root');
            app.el = document.getElementById('form_app');
            app.$button = $('#form_button');

            // Video Player Logic
            const player_open_class = 'player_open';

            $video_cta_link.click(function(event) {
              const mobile = !!document.documentElement.classList.contains('maxw_767');

              event.preventDefault();

              $content.toggleClass(player_open_class);
              window.setTimeout(() => {
                $video_player[0].children[0].play()
              }, 300);
              if (!mobile) {
                // $video_player.addClass('show').show();
              }
            });

            $video_player_close.click(function() {
              $content.removeClass(player_open_class);
              $video_player[0].children[0].pause();
              // $video_player.removeClass('show').hide();
            });

            $overlay.click(function() {
              $content.removeClass(player_open_class);
              $video_player[0].children[0].pause();
            });

            // Fancy Form App
            app.$button.click(function() {
              $(app.parent_el).toggleClass('app_on');
            });

            // Prevent some iOS wierdness
            $video_bg.click(function(event) {
              event.preventDefault();
            });
          },
          finalize() {
            app.rt = Inferno.render(<Form.App />, app.el);
            console.log(app);
          }
        },
        'page_template_template_team': {
          init() {
            const teamNav = new Swiper('.team_nav_slider', {
              spaceBetween: 10,
              // loop: true,
              // loopedSlides: 2,
              centeredSlides: true,
              slidesPerView: 'auto',
              navigation: {
                prevEl: '.team_control_btn-prev',
                nextEl: '.team_control_btn-next',
              },
              grabCursor: true,
              touchRatio: 0.5,
              slideToClickedSlide: true,
              keyboard: true,
            });

            const teamContent = new Swiper('.team_content_slider', {
              spaceBetween: 75,
              // loop: true,
              // loopedSlides: 2,
              simulateTouch: false,
              draggable: false,
              noSwiping: true,
              noSwipingClass: 'no-swipe',
              effect: 'fade',
              fadeEffect: {
                crossFade: true
              },
              breakpoints: {
                768: {
                  simulateTouch: true,
                  draggable: true,
                  noSwiping: false,
                  loop: true,
                  pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                  }
                  // effect: 'slide',
                }
              }
            });

            if (teamNav.controller && teamContent.controller) {
              teamNav.controller.control = teamContent;
              teamContent.controller.control = teamNav;
            }
          }
        },
        'page_template_template_jobs': {
          init() {
            const typehead = document.getElementById('jb_location_typeahead');
            if (!typehead) return false;

            const scriptArea = typehead.parentElement;
            const loc = window.location;
            let params = new URLSearchParams(loc.search);

            const paramObj = {};
            let paramVals = [];

            for (let param of params) {
              paramObj[param[0]] = param[1];
              paramVals[paramVals.length] = param;
            }

            console.log(paramObj, paramVals);

            if (scriptArea && paramObj.ref_arg) {
              const scriptMarkup = scriptArea.innerHTML;
              const betweenString = this.getStringBetwixt(scriptMarkup, " h: '", "'");
              const hash = betweenString[0];
              const time = this.getStringBetwixt(betweenString[1], " t: '", "'")[0];

              params.append('arg', 'jb_search_results');
              params.append('h', hash);
              params.append('t', time);
              params.delete('ref_arg');

              const newUrl = loc.origin + loc.pathname + '?' + params.toString();

              window.location.replace(newUrl);
            }
          },
          getStringBetwixt(rawString, stringHead, stringTail) {
            const stringPos = rawString.indexOf(stringHead);
            const string = rawString.slice(stringPos + stringHead.length);
            const stringEnd = string.indexOf(stringTail) - stringTail.length;

            return [string.slice(0, stringEnd), string ];
          },
          finalize() {

          }
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    let UTIL = {
        fire(func, funcname, args) {
            let fire, namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';
            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents() {
            // Fire common init JS
            UTIL.fire('common');
            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
                console.log(classnm);
            });
            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };
    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
